import { Col, Container, Row } from 'react-bootstrap';
import { motion } from 'motion/react';
import digitalData from '../../data/digitalData.json';

const Plans = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section className='section-lg' id='pricing'>
      <Container>
        <Row className='text-center mb-5'>
          <Col lg={8} className="mx-auto text-center">
            <div className="service-heading mb-3">
              <motion.h6 className="underline-after text-center position-relative z-0"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <span className="position-relative z-1 bg-white text-primary px-3">Pricing Plans</span>
              </motion.h6>
              <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
              >
                Transparent Pricing
              </motion.h2>
            </div>
            <motion.p className="lead text-secondary"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              Choose the plan that fits your business needs and budget. All plans include our core digital marketing services.
            </motion.p>
          </Col>
        </Row>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-4">
            {digitalData.plans.map((plan) => (
              <Col lg={4} md={6} className={plan.id === 3 ? 'mx-auto' : ''} key={plan.id}>
                <motion.div
                  variants={cardVariants}
                  whileHover={{ y: -10, scale: plan.isPopular ? 1.03 : 1.02, transition: { duration: 0.3 } }}
                  className={`card shadow${plan.isPopular ? ' border-success border-opacity-25 border-3' : '-sm'} h-100`}
                >
                  <div className="card-body p-4 p-lg-5">
                    {plan.isPopular && (
                      <motion.div className="position-absolute top-0 start-50 translate-middle"
                        initial={{ opacity: 0, y: -10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 }}
                      >
                        <span className="badge bg-success px-3 py-2">Popular</span>
                      </motion.div>
                    )}
                    <h5 className="fw-semibold text-center mb-4">{plan.name}</h5>
                    <div className="text-center mb-4">
                      <span className="display-5 fw-bold">{plan.price}</span>
                      <span className="text-secondary">{plan.period}</span>
                    </div>
                    <ul className="list-unstyled mb-4">
                      {plan.features.map((feature, index) => (
                        <motion.li key={index} className={`d-flex align-items-center mb-3${!feature.included ? ' text-secondary' : ''}`}
                          initial={{ opacity: 0, x: -10 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: index * 0.1 + 0.3 }}
                        >
                          <i className={`${feature.included ? 'ri-checkbox-circle-fill text-success' : 'ri-close-circle-line'} me-2`}></i>
                          <span>{feature.text}</span>
                        </motion.li>
                      ))}
                    </ul>
                    <div className="text-center">
                      <motion.a href="#contactus" className={`btn btn-${plan.buttonVariant} w-100`}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                      >
                        Get Started
                      </motion.a>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Plans;
